import moment from 'moment';
import { TaxNumberParser } from '@/shared/lib/tax-number';

export const AffectingFactorsValidation = () => {
  const TAX_ID_WEIGHTS = [-1, 5, 7, 9, 4, 6, 10, 5, 7];

  const validChecksum = (value) => {
    if (!value) return true;

    const toNumberArray = (value) => String(value).split('').map(Number);

    const calculateWeightedSum = (digits) =>
      TAX_ID_WEIGHTS?.reduce((acc, weight, index) => acc + digits[index] * weight, 0);

    const calculateChecksum = (sum) => (sum % 11) % 10;

    if (!value) return true;

    const digits = toNumberArray(value);
    const sum = calculateWeightedSum(digits);
    const checksum = calculateChecksum(sum);
    return checksum === digits?.[9];
  };

  const validTaxNumberBirthday = (birthDate, format = 'YYYY-MM-DD') => (taxNumber) => {
    const { extractBirthdayFromTaxNumber } = TaxNumberParser();

    if (!taxNumber || !birthDate) return true;

    const extractedDate = extractBirthdayFromTaxNumber(taxNumber, format);
    if (!extractedDate) return false;

    return moment(extractedDate, format).isSame(moment(birthDate, format), 'day');
  };

  return {
    validChecksum,
    validTaxNumberBirthday,
  };
};
